import { useRef, useState } from "react";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";

const PartnerLogo = ({ src, name, fallbackClass }) => {
  const [err, setErr] = useState(false);
  if (err) return <span className={fallbackClass}>{name}</span>;
  return (
    <img
      src={src}
      alt={name}
      onError={() => setErr(true)}
      className="max-h-full max-w-[90%] object-contain"
      loading="lazy"
    />
  );
};

const NavBtn = ({ dir, onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    aria-label={dir === "left" ? "Înapoi" : "Înainte"}
    className={`hidden md:flex absolute top-1/2 -translate-y-1/2 z-10 h-11 w-11 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-700 shadow-sm hover:bg-slate-50 transition-colors ${
      dir === "left" ? "-left-3" : "-right-3"
    }`}
  >
    {dir === "left" ? <ChevronLeft size={20} /> : <ChevronRight size={20} />}
  </button>
);

/**
 * Carusel unificat pentru "Reduceri în România".
 * Layout identic pe toate rutele; culoarea de accent se transmite prin props.
 */
export const NationalBenefitsCarousel = ({
  items,
  allLink,
  testIdPrefix = "national",
  cardHoverClass = "hover:border-slate-300",
  textClass = "text-slate-800",
  fallbackClass = "font-display font-extrabold text-lg text-slate-800 text-center",
  buttonClass = "text-slate-800 hover:border-slate-400",
}) => {
  const ref = useRef(null);
  const scroll = (d) =>
    ref.current?.scrollBy({ left: d * ref.current.clientWidth * 0.8, behavior: "smooth" });

  return (
    <div>
      <div className="relative" data-testid={`${testIdPrefix}-carousel`}>
        <NavBtn dir="left" onClick={() => scroll(-1)} testId={`${testIdPrefix}-prev`} />
        <div ref={ref} className="flex gap-5 overflow-x-auto scroll-smooth snap-x pb-2 no-scrollbar">
          {items.map((p, i) => (
            <a
              key={p.name}
              href={p.link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`${testIdPrefix}-item-${i}`}
              className={`snap-start shrink-0 w-[36vw] sm:w-60 md:w-60 xl:w-52 aspect-[5/6] flex flex-col items-center justify-center rounded-2xl border border-slate-200 bg-white p-5 md:p-6 hover:-translate-y-1 hover:shadow-xl ${cardHoverClass} transition-[transform,box-shadow,border-color] duration-300`}
            >
              <div className="flex-1 w-full flex items-center justify-center min-h-0">
                <PartnerLogo src={p.logo} name={p.name} fallbackClass={fallbackClass} />
              </div>
              <p className={`mt-3 text-sm font-semibold ${textClass} text-center leading-snug`}>
                {p.offer}
              </p>
            </a>
          ))}
        </div>
        <NavBtn dir="right" onClick={() => scroll(1)} testId={`${testIdPrefix}-next`} />
      </div>

      <div className="mt-8 flex justify-center">
        <a
          href={allLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testIdPrefix}-all`}
          className={`inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-7 py-3.5 text-sm font-bold ${buttonClass} transition-colors`}
        >
          Vezi toate reducerile <ArrowRight size={16} />
        </a>
      </div>
    </div>
  );
};
